import { useTranslation } from "react-i18next";
import { Button } from "../button/button";
import { AlertCircle } from "lucide-react";
import { cn } from "@/lib/utils";

export interface QueryErrorProps {
  title?: string;
  description?: string;
  resource?: string;
  className?: string;
  errors?: Array<Error | null>;
  retries?: Array<VoidFunction | null>;
}

export function QueryError({
  title,
  description,
  resource,
  className,
  errors,
  retries,
}: QueryErrorProps) {
  const { t } = useTranslation();

  const retry = () => retries?.forEach((fn) => fn?.());

  const errorMessages = errors?.map((error) => error?.message).filter(Boolean);

  return (
    <div
      className={cn(
        "flex h-fit gap-5 p-2 bg-destructive-muted text-destructive rounded-sm",
        className
      )}
    >
      <div>
        <AlertCircle className="w-8 h-8" />
      </div>
      <div className="flex flex-col justify-center text-sm gap-1">
        <p className="font-semibold">
          {title ??
            t("errors.queryError", { x: resource ?? t("errors.resources") })}
        </p>
        <p>{description}</p>
        {errorMessages?.map((msg, i) => (
          <p key={i} className="font-light italic">
            {msg}
            <br />
          </p>
        ))}
      </div>
      <Button
        variant="secondary"
        size="default"
        onClick={retry}
        className="ml-auto "
      >
        {t("errors.retry")}
      </Button>
    </div>
  );
}
